import { useState } from 'react';
import { toast } from 'react-toastify';
import { GetCustomerOfferPdf, GetRetailerOfferPdf } from '../Services/OfferService';
import { useConfig } from '../Providers/ConfigProvider';
import { useAuth } from '../Providers/AuthProvider';

const useDownloadCustomerOffer = () => {
    const { authState } = useAuth()
    const [downloadingOfferNo, setDownloadingOfferNo] = useState(-1)
    const { api } = useConfig()

    const downloadCustomerOffer = async (offerId, offerSiteId, offerCustId) => {
        try {
            setDownloadingOfferNo(offerId)
            const response = await GetCustomerOfferPdf(api, offerCustId, offerId, offerSiteId)
            if (response.data.size === 0) {
                toast.error('Brak pliku do wyświetlenia!')
                throw new Error("Plik jest pusty!")
            }

            // Otwieramy PDF w nowej karcie
            /* const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }))
            window.open(url, "_blank"); // Nowa karta */

            //Pobieramy plik PDF
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `oferta_${offerId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success('Pomyślnie pobrano plik PDF');
        } catch (error) {
            console.error('Błąd pobierania pliku PDF:', error)
            toast.error('Nie udało się pobrać pliku!')
        } finally {
            setDownloadingOfferNo(-1)
        }
    }

    const handleDownloadRetailerOfferPdf = async (offerId, offerSiteId, withUnitPrice) => {
        setDownloadingOfferNo(offerId)
        try {
            const response = await GetRetailerOfferPdf(api, authState.custId, offerId, offerSiteId, withUnitPrice)
            if (response.data.size === 0) {
                toast.error('Brak pliku do wyświetlenia!')
                return
            }
            /* const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }))
            window.open(url, "_blank")
 */
            //Pobieramy plik PDF
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `oferta_${offerId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            toast.success('Pomyślnie pobrano plik PDF');
        }
        catch (error) {
            console.log(error)
            toast.error('Nie udało się pobrać pliku!')
        }
        finally {
            setDownloadingOfferNo(-1)
        }
    }

    return { downloadCustomerOffer, handleDownloadRetailerOfferPdf, downloadingOfferNo }
}

export default useDownloadCustomerOffer;
